/**
 * SearchSpring configuration utilities
 * Provides site ID and domain configuration for SearchSpring API requests
 */

import { globalState } from '@/components/helpers/utils'

/**
 * Products are tagged by Shopify Flow with one tag per market they are available in,
 * e.g. "Flow:Available:AU". "Flow:Available:Intl" is an additive catch-all that opts a
 * product into every market except AU, so AU stays opt-in via its own tag only.
 */
const AVAILABLE_TAG_PREFIX = 'Flow:Available:'
const INTL_TAG = `${AVAILABLE_TAG_PREFIX}Intl`
const INTL_EXCLUDED_MARKETS = ['AU']

/**
 * Returns every availability tag that should make a product visible in the current
 * market. Matching is OR-based: a product needs only one of these tags.
 * @returns {string[]} e.g. ['Flow:Available:AU'] or ['Flow:Available:US', 'Flow:Available:Intl']
 */
export function getMarketAvailableTags() {
  const market = globalState?.localization?.market

  if (!market) {
    console.warn(
      '[SearchSpring] getMarketAvailableTags: no market handle found on window.globals.localization.market — availability filtering will not be applied'
    )
    return []
  }

  const tags = [`${AVAILABLE_TAG_PREFIX}${market}`]
  if (!INTL_EXCLUDED_MARKETS.includes(market)) tags.push(INTL_TAG)

  return tags
}

export function getSearchSpringSiteID(category = 'products') {
  return globalState.siteIds[category]
}

export function getSearchSpringDomain(category) {
  switch (category) {
    case 'collections':
      return window.location.host + '/collections?view=ss-feed'
    case 'pages':
      return window.location.host + '/pages/faqs?view=ss-feed'
    case 'blogs':
      return window.location.host + '/blogs/news?view=ss-feed'
    case 'products':
    default:
      return window.location.href
  }
}
